export default "__VITE_ASSET__BWcCTN$w__"